<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" ref="form" :inline="true" label-width="110px">
        <div class="input-box" style="margin-bottom:18px">
          <div>
            <el-form-item label="企业名称：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('cj_jyfpcjjbqkhzb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._aa"></file_Upload></el-button>
      <el-button type="primary" 
            v-if="showBtn[5].isShow"
            v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/就业扶贫车间基本情况汇总表.xlsx" download="就业扶贫车间基本情况汇总表.xlsx">下载模板</a> -->
        下载模板
      </el-button>
    </div> 
    <div class="table">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="就业扶贫车间基本情况汇总表1"
      :visible.sync="centerDialogVisible"
      @close="close"
      width="1400px"
      :modal="false"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" size="mini" :rules="rules" ref="editForm" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="name" label="企业名称：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="企业地址：">
                          <el-input style="width:193px;" v-model="editForm.address"></el-input>
                        </el-form-item>
                        <el-form-item label="扶贫车间类型：">
                          <el-select size="mini" filterable v-model="editForm.workshopType" placeholder="请选择">
                            <el-option
                              v-for="item in $public.chejianleixing"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item prop="ownerName" label="企业负责人：">
                          <el-input style="width:193px;" v-model="editForm.ownerName"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="带动就业人数：">
                          <el-input style="width:193px;" v-model="editForm.helpJobPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="吸纳贫困劳动力就业人数：">
                          <el-input style="width:193px;" v-model="editForm.workShopGetPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="人均工资（元）：">
                          <el-input style="width:193px;" v-model="editForm.salary"></el-input>
                        </el-form-item>
                        <el-form-item label="建筑面积（平方米）：">
                          <el-input style="width:193px;" v-model="editForm.buildArea"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="投资金额（万元）：">
                          <el-input style="width:193px;" v-model="editForm.investment"></el-input>
                        </el-form-item>
                        <el-form-item label="建立时间（认定时间）：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.buildTime"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="建设形式：">
                          <el-input style="width:193px;" v-model="editForm.buildType"></el-input>
                        </el-form-item>
                        <el-form-item label="经营范围：">
                          <el-input style="width:193px;" v-model="editForm.businessRange"></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                          <el-input type="textarea" style="width:193px;" v-model="editForm.remarks"></el-input>
                        </el-form-item>
                        <el-form-item label="批复文号：">
                          <el-input style="width:193px;" v-model="editForm.approvalNumber"></el-input>
                        </el-form-item>
                        <el-form-item label="补助人数：">
                          <el-input style="width:193px;" v-model="editForm.allowancePersons"></el-input>
                        </el-form-item>
                        <el-form-item label="已补助金额：">
                          <el-input style="width:193px;" v-model="editForm.allowanceFee"></el-input>
                        </el-form-item>
                        <el-form-item label="补助资金来源：">
                          <el-input style="width:193px;" v-model="editForm.allowanceSrc"></el-input>
                        </el-form-item>
                        <el-form-item label="补助时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.allowanceTime"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="备注：">
                          <el-input type="textarea" style="width:193px;" v-model="editForm.remarks2"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/bobaiHelpPoorWorkShop',
      form:{socialCode:''},
      type:'20',
      isCreate:false,
      centerDialogVisible:false,
      tableData:[],
      selectRow:[],
      rules:{
        name: [
          { required: true, message: '请输入企业名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key:'name',value:'企业名称'},
        {key:'address',value:'企业地址'},
        {key:'workshopType',value:'扶贫车间类型'},
        {key:'ownerName',value:'企业负责人'},
        {key:'phone',value:'联系电话'},
        {key:'helpJobPersons',value:'带动就业人数'},
        {key:'workShopGetPersons',value:'吸纳贫困劳动力就业人数'},
        {key:'salary',value:'人均工资（元）'},
        {key:'buildArea',value:'建筑面积（平方米）'},
        {key:'investment',value:'投资金额（万元）'},
        {key:'buildTime',value:'建立时间（认定时间）'},
        {key:'buildType',value:'建设形式'},
        {key:'businessRange',value:'经营范围'},
        {key:'remarks',value:'备注'},
        {key:'approvalNumber',value:'批复文号'},
        {key:'allowancePersons',value:'补助人数'},
        {key:'allowanceFee',value:'已补助金额'},
        {key:'allowanceSrc',value:'补助资金来源'},
        {key:'allowanceTime',value:'补助时间'},
        {key:'remarks2',value:'备注'},
      ],
      
    }
  },
  created() {
    this.isShowBtn("BobaiHelpPoorWorkShop")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.buildTime = new Date(newForm.buildTime).getTime()
      newForm.allowanceTime = new Date(newForm.allowanceTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(`${this.api}`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
    //查询列表
    getData() {
      this.$refs['form'].validate((valid)=>{
        if (valid) {
          this.$api.getData('/user/loveUnit',this.form)
          .then(res =>{
            if (res.data.status === 0) {
              this.tableData = JSON.parse(res.data.data)
              this.total = res.data.size
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */

.el-textarea .el-textarea__inner{resize: none;}
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.info-title{
  text-align:center;
  margin:48px 0;
  color:rgb(153,153,153);
}
.text .el-form-item__label{
  text-align:justify;
  text-align-last:justify;
}
</style>